var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchCheckedSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 24,
    viewBox: "0 0 39 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Container"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    width: 39,
    height: 24,
    rx: 12,
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Knob",
    x: 16.5,
    y: 1.5,
    width: 21,
    height: 21,
    rx: 10.5,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchCheckedSvg);
export default __webpack_public_path__ + "static/media/SwitchCheckedSvg.588c708653665651b6ae9c2668218d76.svg";
export { ForwardRef as ReactComponent };